import { render, staticRenderFns } from "./LmParcelariasNewOrEdit.vue?vue&type=template&id=2d334da0&scoped=true"
import script from "./LmParcelariasNewOrEdit.vue?vue&type=script&lang=js"
export * from "./LmParcelariasNewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./LmParcelariasNewOrEdit.vue?vue&type=style&index=0&id=2d334da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d334da0",
  null
  
)

export default component.exports